import { render, staticRenderFns } from "./SceneryDetail.vue?vue&type=template&id=3842391c&scoped=true&"
import script from "./SceneryDetail.vue?vue&type=script&lang=js&"
export * from "./SceneryDetail.vue?vue&type=script&lang=js&"
import style0 from "./SceneryDetail.vue?vue&type=style&index=0&id=3842391c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842391c",
  null
  
)

export default component.exports